/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Kind_OtherInputs */



/**
* | output |
* | --- |
* | "Other" |
*
* @param {Conversations_Kind_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_kind_other = /** @type {((inputs?: Conversations_Kind_OtherInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Kind_OtherInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Overig")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autre")
	return /** @type {LocalizedString} */ ("Other")
});